import { Inject, Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { BehaviorSubject, Observable } from 'rxjs';
import { ShippingState } from "../../../../store/shipping/shipping.reducer";

@Injectable({
  providedIn: 'root'
})
export class NotificationEstablishmentService {
  private isOpenSubject = new BehaviorSubject<boolean>(false);
  isOpen$ = this.isOpenSubject.asObservable();
  phone:string="";
  private isRejectedSubject = new BehaviorSubject<boolean>(false);
  isRejected$ = this.isRejectedSubject.asObservable();

  constructor(
    private store: Store<{ shipping: ShippingState }> // Add store
  ) {
      this.store.select('shipping').subscribe((state) => {
      this.phone = state.phone;
    });
  }

  toggleModal(value?: boolean): void {
    const newValue = value !== undefined ? value : !this.isOpenSubject.value;
    this.isOpenSubject.next(newValue);

    // Si se cierra el modal, resetear el estado de rechazo
    if (value === false) {
      this.setRejected(false);
    }
  }

  setRejected(value: boolean): void {
    this.isRejectedSubject.next(value);
  }

  get isOpen(): boolean {
    return this.isOpenSubject.value;
  }

  get isRejected(): boolean {
    return this.isRejectedSubject.value;
  }

}
